import { render } from "./FormContainer.vue?vue&type=template&id=6951a256&scoped=true"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"

import "./FormContainer.vue?vue&type=style&index=0&id=6951a256&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6951a256"]])

export default __exports__